<script setup>
import TextInput from '@/components/TextInput.vue';
import { ref, reactive } from 'vue';
import ModalShow from '@/components/ModalShow.vue';
import Icon from '@/components/Icon.vue';
import { customApi } from '@/libs/api.js';
import { useConfigStore } from "@/stores/useConfigStore.js";
import EventBus from "@/libs/eventBus";
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(["callBack", "callApi"])

const form = reactive({
    title: '',
    description: '',
    pictures: [],
});

const isShowForm = ref(false);
const errors = ref({});
const dataPreview = ref([]);
const fileInput = ref(null);
const useConfig = useConfigStore();


const submit = () => {
    const formData = new FormData();
    for (const key in form) {
        if (Object.prototype.hasOwnProperty.call(form, key)) {
            if (key === "pictures" && Array.isArray(form[key])) {
                // Nếu là mảng ảnh, lặp qua từng phần tử
                form[key].forEach((file, index) => {
                    formData.append(`${key}[${index}]`, file); // Thêm từng file ảnh
                });
            } else {
                formData.append(key, form[key]); // Thêm các giá trị khác
            }
        }
    }
    formData.append("contract_id", useConfig.contract.id)
    customApi({
            method: 'POST',
            url: 'app/feedback',
            data: formData,
            headers: {
                'Content-Type':'multipart/form-data'
            },
        })
        .then((res) => {
            emit('callApi', res.data);
             EventBus.emit('show-notification', JSON.stringify({
                    id: '',
                    title: "Thông báo!",
                    message: `Cảm ơn bạn đã tạo sự có cho chúng tôi! Ban quản lý sẽ cử người xuống kiểm tra!.`,
                    url: '',
                    type: 'success',
                    showtime: 2000
                }));
            close();
        }).catch((err) => {
            if (err?.response?.status === 422) {
                errors.value = err.response.data.errors;
            }
        });
};

const close = () => {
    emit('callBack', false);
};

const handleFileUpload = (files) => {
    form.pictures = [];
    dataPreview.value = [];
    const arrayFile = files.target.files;
    for (let index = 0; index < arrayFile.length; index++) {
        form.pictures.push(arrayFile[index]);
        dataPreview.value.push(URL.createObjectURL(arrayFile[index]));
    }
    fileInput.value.value = '';
};

const deleteImage = (index) => {
    if (index >= 0 && index < form.pictures.length) {
        dataPreview.value.splice(index, 1);
        form.pictures.splice(index, 1);
    } else {
        alert("Đã có lỗi xảy ra.");
    }
};

</script>

<template>
    <ModalShow :show="show" title="Tạo phản ánh" @call-back="close">
        <div class="w-full pt-4 px-6">
            <TextInput label="Tiêu đề phản ánh" type="text" id="title" v-model="form.title" :errors="errors.title" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="nội dung chi tiết" v-model="form.description" type="textarea" :errors="errors.description"
                id="name" rows="4" placeholder="Nội dung phản ánh..." />
        </div>
        <div class="w-full pt-4 px-6">
            <label for="pictures" class="font-semibold">
                Hình ảnh (0/5)
            </label>
            <div class="w-full flex overflow-x-auto gap-2 pt-1">
                <label for="pictures"
                    class="flex-none w-20 h-20 bg-gray-100 rounded border border-gray-400 flex flex-col justify-center items-center">
                    <Icon name="image-add" class="w-6 h-6 fill-gray-400" />
                    <p class="text-[10px] text-gray-500">Thêm ảnh</p>
                    <input type="file" id="pictures" ref="fileInput" @change="handleFileUpload" accept="image/*"
                        multiple hidden>
                </label>
                <template v-if="dataPreview">
                    <div v-for="(item, index) in dataPreview" :key="index"
                        class="flex-none w-20 h-20 bg-gray-100 rounded border flex flex-col justify-center items-center relative">
                        <div @click="deleteImage(index)"
                            class="w-max h-auto bg-red-500 p-0.5 rounded absolute top-0 right-0">
                            <Icon name="close" class="w-4 h-4 fill-white" />
                        </div>
                        <img :src="item" :alt="'anh_' + index">
                    </div>
                </template>
            </div>
            <p v-if="errors && errors.pictures" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.pictures[0] }}
            </p>
        </div>
        <div class="w-full py-8 flex justify-center items-center px-6">
            <button @click="submit" type="button"
                class="w-full font-bold text-center py-4 bg-main text-white rounded shadow">
                Gửi phản ánh
            </button>
        </div>
    </ModalShow>
</template>
